import { useFetchDocumentsForYearQuery } from "../../../redux";

const useDocumentList = (slug, year) => {
    const data = useFetchDocumentsForYearQuery({ slug, year });
    return {
        ...data
    };
};

export default useDocumentList;